import { Styles } from '@typings/common';

export const startupPasswordBox: Styles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
};
